import { getStoredUser } from "./lib/session";
import { canManagePlatform, canViewPlatformDashboard } from "./types/auth";
import {
  canAccessAssetCenter,
  canAccessBusinessReferenceCenter,
  canAccessCapabilityGraphCenter,
  canAccessEnvironmentCenter,
  canAccessExecutionCenter,
  canAccessIdentityCenter,
  canAccessIntelligenceCenter,
  canAccessTacticsTechniquesCenter,
  canAccessTrafficLibraryCenter,
  canAccessVulnerabilityLibraryCenter,
} from "@airange/shared/index-airange-admin";

type InitialState = {
  currentUser?: {
    is_superuser: boolean;
    platform_roles: string[];
  } | null;
};

export default function access(initialState: InitialState | undefined) {
  const currentUser = initialState?.currentUser ?? getStoredUser();
  const canManage = canManagePlatform(currentUser);

  return {
    canViewDashboard: canViewPlatformDashboard(currentUser),
    canManagePlatform: canManage,
    canManageAssets: canAccessAssetCenter(currentUser),
    canManageEnvironment: canAccessEnvironmentCenter(currentUser),
    canManageExecution: canAccessExecutionCenter(currentUser),
    canManageIdentity: canAccessIdentityCenter(currentUser),
    canManageIntelligence: canAccessIntelligenceCenter(currentUser),
    canManageCapabilityGraph: canAccessCapabilityGraphCenter(currentUser),
    canManageTacticsTechniques: canAccessTacticsTechniquesCenter(currentUser),
    canManageVulnerabilityLibrary: canAccessVulnerabilityLibraryCenter(currentUser),
    canManageBusinessReference: canAccessBusinessReferenceCenter(currentUser),
    canManageTrafficLibrary: canAccessTrafficLibraryCenter(currentUser),
  };
}
